export default __webpack_public_path__ + "static/media/lærervejledning.3cc02b9d.pdf";